<template>
  <svg class="add-icon" xmlns="http://www.w3.org/2000/svg" width="11.532" height="11.651" viewBox="0 0 11.532 11.651">
    <path d="M5.045,11.652v-5.1H0V5.1H5.045V0H6.487V5.1h5.045V6.554H6.487v5.1Z" fill="#fff"/>
  </svg>
</template>

<script>
  export default {
    name: 'AddIcon'
  }
</script>

<style lang="scss">
  
</style>